import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders, HttpRequest } from "@angular/common/http";
import { Observable } from "rxjs/Observable";
import "rxjs/add/operator/map";
import { environment } from "../../environments/environment";
import { Console } from "console";
import { async } from "rxjs/internal/scheduler/async";

@Injectable()
export class AuthenticationService {
  public userInfo = "";
  public access_token = "";
  public refresh_token = "";
  public token = "";

  constructor(private http: HttpClient) {}

  createAuthorizationHeader(headers: Headers) {
    headers.append(
      "Authorization",
      "Basic " +
        btoa(
          "a20e6aca-ee83-44bc-8033-b41f3078c2b6:c199f9c8-0548-4be79655-7ef7d7bf9d20"
        )
    );
  }

  login(username: string, password: string) {
    const body = new URLSearchParams();
    body.set("email", username);
    body.set("password", password);
    body.set("device_type", "0");
    body.set("device_token", "token");
    const options = {
      headers: new HttpHeaders().set(
        "Content-Type",
        "application/x-www-form-urlencoded"
      ),
    };
    return this.http
      .post<any>(environment.apiUrl + "user/login", body.toString(), options)
      .map((user) => {
        // login successful if there's a jwt token in the response
        if (user && user.status === 200) {
          // store user details and jwt token in local storage to keep user logged in between page refreshes
          localStorage.setItem("currentUser", JSON.stringify(user));
        }
        return user;
      });
  }
  // var token = localStorage.getItem("CreatePaypalTokenresp");
  AddPartnerResponse = async () => {
    const response2 = await fetch(
      `${environment.sandBoxUrll}v2/customer/partner-referrals`,
      {
        method: "POST",
        headers: {
          Authorization:
            "Bearer " + localStorage.getItem("CreatePaypalTokenresp"),
          "Content-Type": "application/json",
        },
        body: `{
          "tracking_id": "test123",
          "operations": [
            {
              "operation": "API_INTEGRATION",
              "api_integration_preference": {
                "rest_api_integration": {
                  "integration_method": "PAYPAL",
                  "integration_type": "THIRD_PARTY",
                  "third_party_details": {
                    "features": [
                      "PAYMENT",
                      "REFUND"
                   ]
                  }
                }
              }
            }
          ],
          "partner_config_override": {
              "return_url": "${environment.apiUrl}dashboard",
              "partner_logo_url": "https://www.seasia.com/webstatic/mktg/logo/pp_cc_mark_111x69.jpg"
          },
          "products": [
            "EXPRESS_CHECKOUT"
          ],
          "legal_consents": [
            {
              "type": "SHARE_DATA_CONSENT",
              "granted": true
            }
          ]
      }`,
      }
    ).then(async (response) => {
      const responseData = await Promise.all([response.json()]);
      return responseData;
    });
    localStorage.setItem("AddPartnerResponse", JSON.stringify(response2));
    localStorage.setItem("AddPartnerResponse", JSON.stringify(response2));
    localStorage.setItem("Entryhref", response2[0].links[1].href);
    // if (
    //   response2 &&
    //   response2[0].links[1].href &&
    //   response2[0].links[1].href.length > 0
    // ) {
    //   window.location.href = response2[0].links[1].href;
    // }
  };

  CreatePaypalToken = async () => {
    var formBody: any = [];
    formBody.push("grant_type=client_credentials");

    const resp = await fetch(
      `${environment.sandBoxUrll}v1/oauth2/token`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          Authorization:
            "Basic " +
            btoa(
              "AUQ_6KF0mVLx8w8t6jwMX62uM1PJ4zOWx7FWriLgPIIaRkhc-datN4fT3VyLEkYr_DzJLAwbxPFYJfzv:EGwXUQQ09KcBdc6OqaswafEnMtWhp8vYQB2D-IiU-EWY7hM0iU0Mbu7KVjLRQ61DSHsPm7UZ7W_pHm18"
            ),
          "Accept-Language": "en_US",
        },
        // body: formBody,
        body: formBody,
      }
    ).then(async (response) => {
      const responseData = await Promise.all([response.json()]);
      return responseData;
    });
    localStorage.setItem("CreatePaypalToken", JSON.stringify(resp));
    localStorage.setItem("CreatePaypalTokenresp", resp[0].access_token);
  };

  isLoggedIn() {
    // remove user from local storage to log user out
    if (
      localStorage.getItem("currentUser") &&
      localStorage.getItem("CreatePaypalTokenresp")
    ) {
      return true;
    }
    return false;
  }

  updatePaypalCred(addData) {
    return this.http
      .post<any>(environment.apiUrl + "update-user-pay-pal", addData)
      .map((data) => {
        if (data) {
          return data;
        } else {
          return data;
        }
      });
  }

  isEntryhref() {
    // remove user from local storage to log user out
    if (localStorage.getItem("Entryhref")) {
      return true;
    }
    return false;
  }

  isSetTokenIn() {
    if (
      localStorage.getItem("currentToken") &&
      localStorage.getItem("CreatePaypalTokenresp")
    ) {
      return true;
    }
    return false;
  }

  isCreatePaypalToken() {
    if (
      localStorage.getItem("CreatePaypalToken") &&
      localStorage.getItem("CreatePaypalTokenresp")
    ) {
      return true;
    }
    return false;
  }

  resetPassword(email) {
    const body = new URLSearchParams();
    body.set("email", email);
    const options = {
      headers: new HttpHeaders().set(
        "Content-Type",
        "application/x-www-form-urlencoded"
      ),
    };
    return this.http
      .post<any>(
        environment.apiUrl + "password/email",
        body.toString(),
        options
      )
      .map((resp) => {
        return resp;
      });
  }

  webForgotPassword(username: string, newPassword: string, confirmNewPassword: string, confirmationCode: string) {
    const body = new URLSearchParams();
    body.set("email", username);
    body.set("new_password", newPassword);
    body.set("new_password_confirm", confirmNewPassword);
    body.set("pin", confirmationCode);
    const options = {
      headers: new HttpHeaders().set(
        "Content-Type",
        "application/x-www-form-urlencoded"
      ),
    };
    return this.http
      .post<any>(
        environment.apiUrl + "user/forgotPassword",
        body.toString(),
        options
      )
      .map((resp) => {
        return resp;
      });
  }

  webForgotPasswordPIN(username: string, pin: string) {
    const body = new URLSearchParams();
    body.set("email", username);
    body.set("pin", pin);
    const options = {
      headers: new HttpHeaders().set(
        "Content-Type",
        "application/x-www-form-urlencoded"
      ),
    };
    return this.http
      .post<any>(
        environment.apiUrl + "user/resetToken",
        body.toString(),
        options
      )
      .map((resp) => {
        return resp;
      });
  }

  logout() {
    localStorage.clear();
    // remove user from local storage to log user out
    localStorage.removeItem("currentUser");
    localStorage.removeItem("currentMenu");
  }

  getAuthToken() {
    if (localStorage.getItem("currentUser")) {
      this.userInfo = JSON.parse(localStorage.getItem("currentUser"));
      this.access_token = this.userInfo["access_token"];
      this.refresh_token = this.userInfo["refresh_token"];
      return this.access_token;
    }
  }

  refreshToken() {
    return this.http
      .post<any>(environment.apiUrl + "user/refreshtoken", {
        refresh_token: this.refresh_token,
      })
      .map((res) => {
        return res;
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/_services/authentication.service.ts